import React from 'react';
import PropTypes from 'prop-types';
import { Box, Button, Typography, CircularProgress } from '@material-ui/core';
import VideoPlayer from 'sharedComponents/VideoPlayer';

import useStyles from './useStyles';

const VideoUploader = props => {
  const classes = useStyles();
  const { videoUrl, uploading, uploadProgress, onSend, width, buttonContent } = props;

  return (
    <Box>
      <Box className={classes.playerContainer}>
        <VideoPlayer url={videoUrl} width={width} disabled={uploading} />
        {uploading && (
          <Box className={classes.uploadLayer}>
            <Box position="relative" display="inline-flex">
              <CircularProgress
                className={classes.progressLoader}
                value={uploadProgress}
                variant="determinate"
                size={45}
              />
              <Typography variant="subtitle2" color="inherit" className={classes.uploadProgressLabel}>
                {`${uploadProgress}%`}
              </Typography>
            </Box>
          </Box>
        )}
      </Box>
      <Box mt={3}>
        <Button variant="contained" color="primary" disabled={uploading} onClick={onSend}>
          {buttonContent}
        </Button>
      </Box>
    </Box>
  );
};

VideoUploader.propTypes = {
  videoUrl: PropTypes.string.isRequired,
  uploading: PropTypes.bool.isRequired,
  uploadProgress: PropTypes.number,
  onSend: PropTypes.func.isRequired,
  width: PropTypes.string.isRequired,
  buttonContent: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.string]).isRequired,
};

VideoUploader.defaultProps = {
  uploadProgress: 0,
};

export default VideoUploader;



// WEBPACK FOOTER //
// ./src/sharedComponents/VideoUploader/components/Uploader/Uploader.js